export const actionType = {
    //default
    SHOW_INPUT: 'show_input',
    WIDGET_OPEN: 'widget_open',
    WIDGET_CLOSE: 'widget_close',
    WELCOME_SCREEN_OPEN: 'welcome_screen_open',
    TYPING_ON: 'TYPING_ON',
    OPEN_RATING: 'open_rating',

    //natera
    NATERA_START_CONVERSATION: 'NATERA_START_CONVERSATION',
    INITIALIZE_PERSISTENT_MENU: 'INITIALIZE_PERSISTENT_MENU',
    UPDATE_PERSISTENT_MENU: 'UPDATE_PERSISTENT_MENU',
    UPDATE_USER_INPUT: 'UPDATE_USER_INPUT',
    CLOSE_WIDGET_WITHOUT_CONFIRMATION: 'CLOSE_WIDGET_WITHOUT_CONFIRMATION',
    CLOSE_WIDGET_WITH_CONFIRMATION: 'CLOSE_WIDGET_WITH_CONFIRMATION',
    END_CONVERSATION: 'END_CONVERSATION',
    UNDO_END_CONVERSATION: 'UNDO_END_CONVERSATION',
    OPEN_WIDGET: 'OPEN_WIDGET',
    CLOSE_WIDGET: 'CLOSE_WIDGET',
    KEEP_CHATTING: 'KEEP_CHATTING',
    SWITCH_LANGUAGE: 'SWITCH_LANGUAGE',
    CONTINUE_LANGUAGE_SWITCHING: 'CONTINUE_LANGUAGE_SWITCHING',
    CANCEL_LANGUAGE_SWITCHING: 'CANCEL_LANGUAGE_SWITCHING',
    WIDGET_LANGUAGE_SWITCHED: 'WIDGET_LANGUAGE_SWITCHED',
    BOT_LOADER_LANGUAGE_SWITCHED: 'BOT_LOADER_LANGUAGE_SWITCHED',
    DD_TIMING_EVENT_STOP: 'DD_TIMING_EVENT_STOP'
}
